import { ConfigEntryType } from 'config/config';
import { theme } from 'config/theme';
import FileListFillIcon from 'remixicon-react/FileListFillIcon';
import QuestionFillIcon from 'remixicon-react/QuestionFillIcon';
import ChatQuoteFillIcon from 'remixicon-react/ChatQuoteFillIcon';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Box, FormControlLabel, Checkbox } from '@mui/material';

type ArticleTypeFilterFieldProps = {
  filter: ConfigEntryType;
};

export const ARTICLE_TYPES = [
  {
    name: 'POST',
    label: 'Post',
    icon: <FileListFillIcon color={theme.palette.custom.pirateGold} size={18} />,
  },
  {
    name: 'QUESTION',
    label: 'Ask',
    icon: <QuestionFillIcon color={theme.palette.custom.dodgerBlue} size={18} />,
  },
  {
    name: 'SUGGESTION',
    label: 'Suggest',
    icon: <ChatQuoteFillIcon color={theme.palette.custom.cloverGreen} size={18} />,
  },
];

function ArticleTypeFilterField({ filter }: ArticleTypeFilterFieldProps) {
  const {
    control,
    formState: { isSubmitting },
    setValue,
  } = useFormContext<Record<string, any>>();
  const selectedValues = useWatch({ control, name: filter.entryCode, defaultValue: [] });

  const handleChange = (itemName: string) => {
    const newValues: string[] = selectedValues.includes(itemName)
      ? selectedValues.filter((value) => value !== itemName)
      : [...selectedValues, itemName];

    setValue(filter.entryCode, newValues, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <Box sx={{ mt: -0.5 }}>
      <Controller
        control={control}
        render={({ field: radioField }) => (
          <Box sx={{ display: 'flex' }}>
            {ARTICLE_TYPES.map((item) => (
              <Box key={item.name}>
                <FormControlLabel
                  {...radioField}
                  onChange={() => handleChange(item.name)}
                  control={
                    <Box sx={{ alignItems: 'center', display: 'flex' }}>
                      <Checkbox
                        checked={selectedValues.includes(item.name)}
                        value={item.name}
                        size="small"
                      />
                      {item.icon}
                    </Box>
                  }
                  label={item.label}
                  disabled={isSubmitting}
                />
              </Box>
            ))}
          </Box>
        )}
        name={filter.entryCode}
      />
    </Box>
  );
}

export default ArticleTypeFilterField;
